
import { pipelineContext, runPipeline } from './pipelineRunner.js'
import { claimantComparePipeline } from './claimantComparePipeline.js'

let runClaimantComparePipeline = (selectedClaim) => {

    let context = pipelineContext(selectedClaim)


    return runPipeline(claimantComparePipeline, context)
}

export { runClaimantComparePipeline }